import { render, staticRenderFns } from "./ContainerSingle.vue?vue&type=template&id=47238bd3&"
import script from "./ContainerSingle.vue?vue&type=script&lang=js&"
export * from "./ContainerSingle.vue?vue&type=script&lang=js&"
import style0 from "./ContainerSingle.vue?vue&type=style&index=0&id=47238bd3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports